export default "__VITE_ASSET__CLDm3for__"